export const normalizeRecruitmentStepTypes = (types, t) => {
    if (!types) {
        return [{ name: t('Status'), value: '' }];
    }
    if (Array.isArray(types)) {
        return types;
    }

    return [
        { name: t('Status'), value: '' },
        ...Object.entries(types)
            .filter(([, { disabled }]) => !disabled)
            .map(([value, data]) => ({ ...data, value })),
    ];
};

